import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import HelpIcon from '@material-ui/icons/Help';
import Tooltip from '@material-ui/core/Tooltip';

const useStyles = makeStyles(theme => ({
  large: {
    fontSize: 14,
    padding: theme.spacing(2),
  },
  noMargin: {
    margin: theme.spacing(2),
  },
}));

export default function HelpTip(props) {
  const classes = useStyles();

  return (
    <div style={{padding:'1em'}}>
      <Tooltip 
        title={props.message} 
        placement={props.placement} 
        classes={{ tooltip: classes.large }} 
        interactive
      >
        <HelpIcon />
      </Tooltip>
    </div>
  );
}